<template>
  <MailingModal :mailing-modal="mailing.modal" :class="{'show d-block': showModal}" @closeModal="handleCloseModal" />
  <section class="mailing bg-primary position-relative">
    <BannerVector width="626" height="343" class="d-block bg-vector position-absolute opacity-50" />
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-8">
          <div class="download d-flex justify-content-start">
            <WeirdMailIcon />
          </div>
          <h2>{{ mailing.title }}</h2>
          <p v-html="mailing.description" />
        </div>
        <div class="col-12 col-lg-4">
          <MailingForm :form="mailing.form" :clearForm="clearForm" @submit="handleSubmit" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DownloadIcon from "@/assets/icons/download-icon";
import MailingForm from "@/components/mailing/MailingForm";
import WeirdMailIcon from "@/assets/icons/weirdMailIcon";
import MailingModal from "@/components/mailing/MailingModal.vue";
import BannerVector from "@/assets/icons/banner-vector";

export default {
  components: {MailingModal, WeirdMailIcon, MailingForm, DownloadIcon, BannerVector},
  props: {
    mailing: {
      title: String,
      description: HTMLElement,
      form: {
        formName: String,
        firstName: {
          placeholder: String,
          label: String
        },
        lastName: {
          placeholder: String,
          label: String
        },
        email: {
          placeholder: String,
          label: String
        },
        button: {
          text: String
        },
        errors: {
          empty: String,
          email: String,
          containLetters: String,
          onlyNumbers: String
        }
      },
      modal: {
        logo: {
          alt: 'text',
          link: 'text'
        },
        title: 'text',
        description: 'html',
        button: {
          text: 'text',
          link: 'text'
        }
      }
    }
  },
  data(){
    return {
      showModal: false,
      clearForm: false,
    }
  },
  methods: {
    handleSubmit(close){
      close && (this.$data.showModal = false)
      !close && (this.$data.showModal = true)
    },
    handleCloseModal() {
      this.showModal = false;
      this.clearForm = true;
    }
  }
}
</script>
